export default __webpack_public_path__ + "static/media/bg-image.a76841bb.png";